import { useQueryClient } from '@tanstack/react-query';

import { useMemo } from 'react';

import { usePutTkv2CommentaryAttachmentAPI } from '../../hooks/api/toolkitComponents.ts';
import { useToolkitContext } from '../../hooks/api/toolkitContext.ts';

export const usePutTkv2Commentaries = (orderID: string) => {
  const queryClient = useQueryClient();
  const tkContext = useToolkitContext();

  const params = useMemo(() => ({ pathParams: { orderID } }), [orderID]);

  const queryKey = tkContext.queryKeyFn({
    path: '/api/v2/orders/{orderID}/attachments/commentary',
    operationId: 'getTkv2CommentaryAttachmentAPI',
    variables: params,
  });

  return usePutTkv2CommentaryAttachmentAPI({
    onMutate: async (commentaries) => {
      // Cancel any outgoing refetches
      // (so they don't overwrite our optimistic update)
      await queryClient.cancelQueries({ queryKey });

      // Snapshot the previous value
      const previousCommentaries = queryClient.getQueryData(queryKey);

      // Optimistically update to the new value
      queryClient.setQueryData(queryKey, commentaries);

      // Return a context with the previous and new todo
      return { previousCommentaries, commentaries };
    },
    // If the mutation fails, use the context we returned above
    onError: (_err, _newCommentary, context) => {
      queryClient.setQueryData(
        queryKey,
        (context as { previousCommentaries: unknown }).previousCommentaries,
      );
    },
  });
};
